import getAdvertisingOptions from 'mini-options-store/lib/selectors/gdprAdsV3Option/getAdvertisingOptions';
import getCachedEUEmailPolicyOptInBit from './getCachedEUEmailPolicyOptInBit';
import NativeAdUserFlight from './NativeAdUserFlight';
import { emailadsOptInStore } from 'owa-emailadsoptin-store';
import { getNativeFinalFlightForUser } from './getNativeAdProperties';
import { isConsumer } from 'owa-shared-start/lib/sessionDiagnostics';
import { isEUEmailAdsPolicyMarket } from './isEUEmailAdsPolicyMarket';
import { isGdprAdMarket } from './isGdprAdMarket';

export function getNativeAdShowStatus(): NativeAdUserFlight {
    // Get the native ad flight based on the static properties like age, market, paid status. These information will never change during a session and we do not need calculate it again.
    const staticNativeAdFlight = getNativeFinalFlightForUser();

    const { optInBit } = getAdvertisingOptions();

    if (staticNativeAdFlight === NativeAdUserFlight.NoNativeAd) {
        return NativeAdUserFlight.NoNativeAd;
    }

    if (isGdprAdMarket() && isConsumer() && optInBit == 2) {
        return NativeAdUserFlight.PrebidMobileAllInbox;
    }

    if (isGdprAdMarket() && isConsumer() && optInBit == 1) {
        return NativeAdUserFlight.PrebidMobileBannerAd;
    }

    if (isEUEmailAdsPolicyMarket()) {
        if (emailadsOptInStore.emailAdsOptInBit === 2) {
            return NativeAdUserFlight.PrebidMobileAllInbox;
        } else if (
            emailadsOptInStore.emailAdsOptInBit === -1 &&
            getCachedEUEmailPolicyOptInBit() === 2
        ) {
            return NativeAdUserFlight.PrebidMobileAllInbox;
        } else if (
            emailadsOptInStore.emailAdsOptInBit != 1 &&
            emailadsOptInStore.emailAdsOptInBit != 2
        ) {
            return NativeAdUserFlight.PrebidMobileAllInbox;
        } else {
            return NativeAdUserFlight.PrebidMobileBannerAd;
        }
    }

    return staticNativeAdFlight;
}
